import ms from 'milliseconds'

import createListBundle, { defaultInitialState } from '~/src/Lib/createListBundle'
import createLogger from '~/src/Lib/Logging'
import { EMPTY_ARRAY } from '~/src/Lib/Utils'
import { KpiProfile as schema } from '~/src/Store/Schemas'

const logger = createLogger('RD/kpiRecipes#bundle')

const initialState = {
  ...defaultInitialState,
}

export default createListBundle({
  entityName: 'kpiProfiles',
  name: 'kpiProfiles',
  initialState,
  actions: EMPTY_ARRAY,
  schema,
  permissions: { keys: ['view_cultivar_profiles'] },
  fetchHandler: ({ apiFetch }) => apiFetch('/kpiProfiles/'),
  staleAfter: ms.minutes(60),
  retryAfter: ms.seconds(15),
})
